<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->
    <div id="header" :class="{fixednav: scrolldown === true}" class="full-header clearfix" style="height: 75px;">
      <div id="header-wrap" style="padding-top: 15px;" >
        <div class="container clearfix">
          <div   id="primary-menu-trigger" class="navbarhidden big-show" @click="menuTrigger()">
            <i class="icon-reorder"></i>
          </div>
          <div   id="primary-menu-trigger"  class="small-show" @click="menuTrigger()">
            <i class="icon-reorder"></i>
          </div>

          <!-- Logo
          =============================================-->
          <div id="logo" class="big-show" style="padding: 1opx; cursor:pointer;" @click="$router.push('/')"  >
            
            <img :src="getApiPath('a8ca6b9f-e7f1-43e2-b23d-12840b697b8d.png')" alt="W" /><!-- <img :src="getFullPath('shopLogo.png')" alt="" /> -->
          </div>
          <!-- <div id="logo2" class="small-show" style="padding: 1opx; cursor:pointer;" @click="$router.push('/')"  >
            
            <img :src="getApiPath('a8ca6b9f-e7f1-43e2-b23d-12840b697b8d.png')" alt="W" />
          </div> -->
          <!-- #logo end -->

          <!-- Primary Navigation
          =============================================-->
          <nav id="primary-menu" class="style-2 with-arrows">
            <div class="row search_row" style="width: 75%;" v-show="show_search" >
              <div class="col-lg-9 col-md-9 col-9">
                <input ref="thesearch" @keyup.enter="submitSearch()" v-model="searchText" style= "" placeholder=" หาชุดอะไรดีนะ ?" class="form-control search-text"  /> 
               </div>
                <div class="col-lg-3 col-md-3 col-3" style="padding-top: 15px; cursor: pointer; ">
                  <div @click="clearSearch()"  style="font-weight: bold; border-radius: 15px; border : 1px solid #e4e4e4; margin-bottom: 10px;" :class="{hh: show_search === 0}" >X</div>
                 </div>
           </div>
            <ul :class="{hh: show_search === 1}" 
              id="primary-dropdown-menu"
              style="font-family:supermarket !important; font-size:16px;"
            >
              <!-- <li :class="{current: selected === 0}" @click="hideMenu(0)">
                <router-link to="/">หน้าแรก</router-link>
              </li> -->
              <!-- Mega Menu
              =============================================-->

              <li class="mega-menu-title" :class="{current: selected === 1}" @click="hideMenu(1)">
                <router-link to="/rental-list/อัลบั้มรวมชุดเช่า">อัลบั้มรวมชุดเช่า</router-link>
              </li>
              <li class="mega-menu-title" :class="{current: selected === 2}" @click="hideMenu(2)">
                <router-link to="/rental-list/แบรนด์ Poem"> แบรนด์ Poem</router-link>
              </li>

              <li class="mega-menu-title" :class="{current: selected ===  3}" @click="hideMenu(3)">
                <router-link to="/rental-list/เดรสสั้น">เดรสสั้น</router-link>
              </li>
              <!-- <li class="mega-menu-title" :class="{current: selected === 11}" @click="hideMenu(11)">
                <router-link to="/rental-list/พลัสไซส์">พลัสไซส์</router-link>
              </li> -->
              
              <li class="mega-menu-title" :class="{current: selected === 4}" @click="hideMenu(4)">
                <router-link to="/rental-list/เดรสยาว">เดรสยาว</router-link>
              </li>

              
<!-- 
              <li class="mega-menu-title" :class="{current: selected === 5}" @click="hideMenu(5)">
                <router-link to="/rental-list/อื่นๆ">อื่นๆ</router-link>
              </li>
              <li class="mega-menu-title" :class="{current: selected === 6}" @click="hideMenu(6)">
                <router-link to="/rental-list/สินค้าขาย">สินค้าขาย</router-link>
              </li> -->
              <li class="mega-menu-title" :class="{current: selected === 7}" @click="hideMenu(7)">
                <router-link to="/howtorent">วิธีเช่า</router-link>
              </li>
              <li class="mega-menu-title" :class="{current: selected === 8}" @click="hideMenu(8)">
                <router-link to="/faq">FAQ</router-link>
              </li>
              <!-- <li class="mega-menu-title" :class="{current: selected === 9}" @click="hideMenu(9)">
                <router-link to="/blog">Blog</router-link>
              </li>-->
              <li class="mega-menu-title" :class="{current: selected === 10}" @click="hideMenu(10)">
                <router-link to="/contact-us">ติดต่อเรา</router-link>
              </li>
          
              <li class="mega-menu-title">
                <i
                  @click="showSearch()"
                  style="font-size:16px; padding: 15px 13px;cursor: pointer;"
                  class="icon-search3"
                ></i>
              </li>
                <li class="mega-menu-title">
                <!-- <i
                  @click="showSearch()"
                  style="font-size:16px; padding: 15px 13px;cursor: pointer;"
                  class="icon-search3"
                ></i> -->

                <router-link to="/cart">
                    <i style="font-size: 32px; color: #a7a7a7; " class="icon-shopping-basket"></i>
                    <div
                      v-if="$store.state.listnumber > 0"
                      style="position: absolute; top: 60%; left: 70%; ;width: 20px; height:20px; border-radius: 15px; background-color: red; color: white; font-size: 9px;"
                    >{{$store.state.listnumber}}
                    </div>
                
                </router-link>
              </li>
            </ul>
          </nav>
          <!-- #primary-menu end -->
        </div>
      </div>
    </div>
    <router-view />
    <ft></ft>
  </div>
</template>
<script>
import store from "@/store.js";
import Ft from "@/views/Ft.vue";

import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      searchText: "",
      show_search: 0,
      scrolldown: false,
      selected: 0,
      showNavbar: true,
      lastScrollPosition: 0
    };
  },

  mounted() {
    // window.addEventListener("scroll", this.onScroll);
    var it = JSON.parse(localStorage.getItem("rentalitem"));
    if (it !== null && it !== undefined) {
      store.state.listnumber = it.length;
    } else {
      store.state.listnumber = 0;
    }

    // var x = window.scrollX;
    // var y = window.scrollY;
    // document.getElementById("demo").innerHTML =
    //   "Horizontally: " + x + "px<br>Vertically: " + y + "px";
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {

    clearSearch(){
      this.searchText = "";
      this.show_search = 0;
    },
    submitSearch(){
     

      if(this.$route.params.searchtext !== this.searchText)
      {
        return this.$router.push("/search/"+ this.searchText );
      }
     
    },
    showSearch(){
        this.show_search = 1;
       this.$nextTick(() => this.$refs.thesearch.focus())
        
    },
    hantai(){
      return !this.show_search;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (window.scrollY > 60) {
        this.scrolldown = true;
      } else {
        this.scrolldown = false;
      }
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    hideMenu(num) {
      this.selected = num;
      var primaryDropdownMenu = document.getElementById(
        "primary-dropdown-menu"
      );
      if (this.detectmob()) {
        primaryDropdownMenu.style.display = "none";
      }
    },
    menuTrigger() {
      var primaryDropdownMenu = document.getElementById(
        "primary-dropdown-menu"
      );

      if (
        primaryDropdownMenu.style.display === "none" ||
        primaryDropdownMenu.style.display === null ||
        primaryDropdownMenu.style.display === undefined ||
        primaryDropdownMenu.style.display === ""
      ) {
        primaryDropdownMenu.style.display = "block";
      } else {
        primaryDropdownMenu.style.display = "none";
      }
    },
    getFullPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.imageUrl + "defaultimage.png";
      } else {
        return store.state.imageUrl + mainImage;
      }
    }
  },
  components: {
    Ft
  }
};
</script>
<style>
.search-text{
  font-family: 'mitr-regular' !important;
  padding-left: 30px; width: 75%; border: 0 white solid; padding-top: 5px; margin-right: 10px; font-size: 1.3rem;
}
@media only screen and (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }


}
@media only screen and (min-width: 800px) {
 
  .small-show{
    display: none !important;
  }
  .big-show{
    display: block;
  }
}
@media only screen and (max-width: 800px) {
  .search-text{
      font-size: 0.9rem !important;
      font-family: 'mitr-regular' !important;
      width:100% !important;
  }
  .search_row{
     width:100% !important;
  }
  #logo img {
    padding-top: 20px;
    margin-left: 30px;
    height: 70px !important;
  }

  .small-show{
    display: inline-block !important;
  }
  .big-show{
    display: none;
  }
  .style-2{
    width:100% !important;
  }
}


@media only screen and (min-width: 900px) {
  
  #primary-menu {
    display: inline-block !important;
    
  }
  .search_row
  {
    width: 100% !important;
  }
  #primary-dropdown-menu {
    display: block ;
  }
}
#app {
  font-family: "Mitr", "supermarket", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbarhidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.fixednav {
  position: fixed !important;
  z-index: 999 !important;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
  margin: 0 auto !important;
  width: 100%;
  top: 0;
}

.hh{
 display: none !important;

}


</style>
